import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'
import moment from 'moment'
import Detail from '~/_shared/models/Detail'

export const state = {
  details: [],
  total: 0,
  detail: Detail,
  detailName: {},
  hasDetailing: null
}

export const getters = {
  details: state => state.details,
  total: state => state.total,
  detail: state => state.detail,
  detailName: state => state.detailName,
  hasDetailing: state => state.hasDetailing
}

export const mutations = {
  DETAILS (state, data) {
    state.details = data
  },
  TOTAL (state, data) {
    state.total = data
  },
  DETAIL (state, data) {
    state.detail = data
  },
  DETAIL_NAME (state, data) {
    state.detailName = data
  },
  HAS_DETAILING (state, data) {
    state.hasDetailing = data
  }
}

export const actions = {
  async fetchAll ({ commit }, filterData) {
    await axios.get(
      laroute.route('details-filter', { companyAbbr: store.getters['auth/company'], ...filterData })
    ).then(res => {
      res.data.items.map((detail) => {
        detail.created_at = moment(detail.created_at).format('YYYY-MM-DD')
      })

      commit('DETAILS', res.data.items)
      commit('TOTAL', res.data.total)
    }).catch(err => {
      console.log(err)
    })
  },

  async getOne ({ commit }, id) {
    const { data } = await axios.get(laroute.route('get-detail', { companyAbbr: store.getters['auth/company'], id }))

    commit('DETAIL', new Detail(data.data))
  },

  async getDetailSequence ({ commit }, id) {
    const { data } = await axios.get(laroute.route('get-detail-sequence', { id }))

    commit('DETAIL_NAME', data.data)
  },

  async create ({ commit }, detail) {
    const { data } = await axios.post(laroute.route('create-detail'), { detail })

    commit('DETAIL', new Detail(data.data))
  },

  async addItems ({ commit }, { id, items }) {
    await axios.post(laroute.route('add-detail-operations'), { id, items })
  },

  async delete ({ commit }, id) {
    await axios.delete(laroute.route('delete-detail', { id }))
  },

  async deleteItem ({ commit }, id) {
    await axios.delete(laroute.route('delete-detail-operation', { id }))
  },

  async update ({ commit }, { id, detail, operations }) {
    await axios.patch(laroute.route('update-detail', { id }), { detail, operations })
  },

  async getDrawingsAndOperations ({ commit }, items) {
    const { data } = await axios.get(laroute.route('get-drawings-and-operations', { items }))

    commit('DETAILS', data)
  },

  async checkOnDrawingsExisting ({ commit }, itemMasterId) {
    const { data } = await axios.get(laroute.route('check-item-master-on-drawings-existing', { itemMasterId }))

    commit('HAS_DETAILING', data.data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/detailing.js